import { GetSettingsInteractor } from "@use-cases/GetSettingsInteractor";
import { LocalStorageSettings } from "@adapters/LocalStorageSettings";

export const CGetSettingsInteractor = new GetSettingsInteractor(
  new LocalStorageSettings()
);
